import React from 'react';
import { Swipeable } from 'react-swipeable'
import { QuestionProps } from '../Quiz/Quiz';
import './Gauge.scss';

const Gauge: React.FC<QuestionProps> = ({ question, answers, notes, nextSlide, onAnswerSelect }) => {
  const [selected, setSelected] = React.useState<number>(null);

  const classToApply = selected ? `goto${selected}` : '';

  const goto = (newSelected) => {
    //onAnswerSelect(question.id, newSelected, true)
    setSelected(newSelected);
  };

  const next = () => {
    onAnswerSelect(question.id, selected, true);
    nextSlide();
  };

  const swipe = (direction) => {
    if (direction === 'left') {
      switch (selected) {
        case 22:
          setSelected(null);
          return;
        case 90:
          setSelected(22);
          return;
        case 160:
          setSelected(90);
          return;
      }
    } else if (direction === 'right') {
      switch (selected) {
        case null:
          setSelected(22);
          return;
        case 22:
          setSelected(90);
          return;
        case 90:
          setSelected(160);
          return;
      }
    }
  };

  return (
    <div className={'ma-slide'}>
      <h2>{question.question}</h2>
      <p className={'instructions'}>DIAL YOUR INTEREST UP OR DOWN:</p>
      <Swipeable
        onSwipedLeft={() => swipe('left')}
        onSwipedRight={() => swipe('right')}
      >
          <div className={`gaugeOuterWrapper ${classToApply}`}>
            {/* <label id="not-interested">Not interested</label> */}
            <div className={`gaugeWrapper`}>
              <div className={`gaugeBackground`}>
                <div className={'gauge'}>
                  <div onClick={() => goto(22)} className={'yes'}></div>
                  <div onClick={() => goto(160)} className={'maybe'}></div>
                  <div onClick={() => goto(90)} className={'no'}></div>
                </div>
              </div>
            </div>
            <div className={'rotator'}></div>
            <div className={'pointer'}></div>
          </div>
      </Swipeable>
      <p style={{ paddingTop: 40 }}>{selected ? notes : '\u00A0'}</p>
      <button className={'next'} disabled={selected ? false : true} onClick={next}>
        Next &gt;
      </button>
    </div>
  );
};

export default Gauge;
